import { useSessionStore } from "../../../state/src/useSessionStore";
import { ReceiveMoneyPostValidationParameter } from "../view-models/ReceiveMoneyPostValidationParameter";

export const buildReceiveValidationRequestFromStore = () => {
    const state = useSessionStore.getState() as any;
    const request = new ReceiveMoneyPostValidationParameter();

    // BasicRequest fields
    request.agentID = state.agentId || undefined;
    request.unitProfileID = state.unitProfileId || undefined;
    
    const referenceNumberSearchResult = (state.referenceNumberSearchResult || {}) as any;
    request.mgiTransactionSessionId = referenceNumberSearchResult?.MgiTransactionSessionID;
    request.referenceNumber = referenceNumberSearchResult?.ReferenceNumber;
    request.receiveCurrency = referenceNumberSearchResult?.ReceiveCurrency;
    request.receiverDob = state.RecieverDOB;
    request.receiverAddress = state.receiverAddress;
    request.receiverCity = state.receiverCity;
    request.receiverZipCode = state.receiverZipCode;
    request.receiverState = state.receiverState;
    // Fallback: parse receiverDOBString (MM/DD/YYYY)
    if (!request.receiverDob && state.RecieverDOBString) {
        try {
            const parts = String(state.RecieverDOBString).split("/");
            if (parts.length === 3) {
                const mm = parseInt(parts[0], 10);
                const dd = parseInt(parts[1], 10);
                const yyyy = parseInt(parts[2], 10);
                const d = new Date(yyyy, mm - 1, dd);
                if (!isNaN(d.getTime())) {
                    request.receiverDob = d;
                }
            }
        } catch { }
    }
    request.agentCheckAmount = referenceNumberSearchResult?.AgentCheckAmount;
    request.receiverCountry =  'USA';
    request.receiverPhotoIdType = state.selectedIdTypeValue;
    request.receiverPhotoIdNumber = state.receiverPhotoIdNumber;
    request.receiverPhotoIdState = state.selectedIdPhotoIdStateAbbr;
    request.receiverPhotoIdCountry =  state.selectedIdPhotoIdCountry;
    request.consumerId = "0";
    request.receiverPhone = state.phoneNumber;
    request.formFreeStaging = true;


    return request;
}